var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import * as moment from "moment";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
var Rate = /** @class */ (function (_super) {
    __extends(Rate, _super);
    function Rate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.now = moment().startOf('day');
        return _this;
    }
    Object.defineProperty(Rate.prototype, "localStart", {
        get: function () {
            return typeof this.start === "string"
                ? moment(this.start)
                : this.start;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rate.prototype, "localEnd", {
        get: function () {
            return typeof this.end === "string"
                ? moment(this.end)
                : this.end;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rate.prototype, "unavailable", {
        get: function () {
            return (this.type === 'date' && this.localEnd && this.localEnd.isBefore(this.now));
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Prop({ type: String, default: "dddd, LL" })
    ], Rate.prototype, "dateFormat", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], Rate.prototype, "type", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], Rate.prototype, "name", void 0);
    __decorate([
        Prop({ type: String })
    ], Rate.prototype, "note", void 0);
    __decorate([
        Prop({ type: Boolean, required: true })
    ], Rate.prototype, "isFree", void 0);
    __decorate([
        Prop({ type: Number, default: 0 })
    ], Rate.prototype, "price", void 0);
    __decorate([
        Prop({ type: String })
    ], Rate.prototype, "priceNote", void 0);
    __decorate([
        Prop({ type: Number })
    ], Rate.prototype, "minAge", void 0);
    __decorate([
        Prop({ type: Number })
    ], Rate.prototype, "maxAge", void 0);
    __decorate([
        Prop({ type: [Object, String] })
    ], Rate.prototype, "start", void 0);
    __decorate([
        Prop({ type: [Object, String] })
    ], Rate.prototype, "end", void 0);
    Rate = __decorate([
        Component({
            name: "Rate",
            components: {
                "b-row": Row,
                "b-col": Col
            }
        })
    ], Rate);
    return Rate;
}(Vue));
export default Rate;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Rate.vue
// module id = 171
// module chunks = 0 1 5